import stages from '../constants/stages';

const TYPE = Symbol('stage-contract-type');

const SubmitPreProcessingContract = Object.freeze({
  id: stages.SUBMIT_PRE_PROCESSING,
  create: (modifiedFieldsValues) => {
    if (!modifiedFieldsValues || typeof modifiedFieldsValues !== 'object') {
      throw new TypeError(
        `${String(
          stages.SUBMIT_PRE_PROCESSING
        )} contract validation: modifiedFieldsValues must be an object`
      );
    }

    return Object.freeze({ [TYPE]: stages.SUBMIT_PRE_PROCESSING, modifiedFieldsValues });
  },
  get: (result) => result?.modifiedFieldsValues ?? null,
  isValid: (result) => result?.[TYPE] === stages.SUBMIT_PRE_PROCESSING,
});

const SubmitActionsGenerationContract = Object.freeze({
  id: stages.SUBMIT_ACTIONS_GENERATION,
  create: (actions) => {
    if (!Array.isArray(actions)) {
      throw new TypeError(
        `${String(stages.SUBMIT_ACTIONS_GENERATION)} contract validation: actions must be an array`
      );
    }

    return Object.freeze({ [TYPE]: stages.SUBMIT_ACTIONS_GENERATION, actions });
  },
  get: (result) => result?.actions ?? null,
  isValid: (result) => result?.[TYPE] === stages.SUBMIT_ACTIONS_GENERATION,
});

const SubmitTraitsGenerationContract = Object.freeze({
  id: stages.SUBMIT_TRAITS_GENERATION,
  create: (traits) => {
    if (typeof traits !== 'object') {
      throw new TypeError(
        `${String(stages.SUBMIT_TRAITS_GENERATION)} contract validation: traits must be an object`
      );
    }

    return Object.freeze({ [TYPE]: stages.SUBMIT_TRAITS_GENERATION, traits });
  },
  get: (result) => result?.traits ?? null,
  isValid: (result) => result?.[TYPE] === stages.SUBMIT_TRAITS_GENERATION,
});

export {
  SubmitPreProcessingContract,
  SubmitActionsGenerationContract,
  SubmitTraitsGenerationContract,
};
